<template>
  <div class="py-8">
    <BaseContainer v-if="isIndexPage">
      <header class="mb-6">
        <h1
          class="md:text-5xl !leading-[62px] !text-[32px] text-[32px] lg:block hidden"
        >
          {{ $t('pages.home.collabs.title') }}
        </h1>
      </header>
    </BaseContainer>

    <BaseContainer class="px-[50px] min-[1330px]:px-5">
      <div class="relative">
        <div
          class="collabs-c-button-prev absolute -left-[25px] min-[1330px]:-left-[40px] top-[50%] -translate-x-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer"
        >
          <Icon name="arrow-left" />
        </div>
        <nuxt-error-boundary @error="() => {}">
          <Swiper
            :modules="[SwiperEffectCreative, SwiperNavigation, SwiperAutoplay]"
            slides-per-view="auto"
            :space-between="10"
            :loop="true"
            :navigation="{
              enabled: true,
              disabledClass: '!bg-gray-10 !text-typo-disabled',
              nextEl: '.collabs-c-button-next',
              prevEl: '.collabs-c-button-prev'
            }"
            class="max-[400px]:max-w-[280px]"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false
            }"
            :creative-effect="{
              prev: {
                shadow: false,
                translate: ['-20%', 0, -1]
              },
              next: {
                translate: ['100%', 0, 0]
              }
            }"
            :breakpoints="{
              500: {
                slidesPerView: 3,
                spaceBetween: 10
              },
              720: {
                slidesPerView: 6,
                spaceBetween: 10
              },
              1200: {
                slidesPerView: 8,
                spaceBetween: 10
              }
            }"
          >
            <SwiperSlide
              v-for="(slide, index) in [
                ...(pageData || []),
                ...(pageData || [])
              ]"
              :key="index"
              class="max-w-[85px] min-[400px]:max-w-[100px] md:max-w-[166px] lg:max-w-[166px]"
            >
              <NuxtLinkLocale
                class="block border border-border-divider select-none"
                :to="slide.href"
                prefetch
              >
                <NuxtImg
                  format="webp"
                  alt="collab"
                  :src="slide.imageUrl"
                  loading="lazy"
                />
              </NuxtLinkLocale>
              <div class="font-bold text-center mt-2 min-h-[48px]">
                {{ slide.title }}
              </div>
            </SwiperSlide>
          </Swiper>
        </nuxt-error-boundary>
        <div
          class="collabs-c-button-next absolute -right-[25px] min-[1330px]:-right-[40px] top-[50%] translate-x-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer"
        >
          <Icon name="arrow-right" />
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { cmsRepository } from '~/repository/cmsRepository'

const route = useRoute()
const { locale } = useI18n()
const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: pageData } = await useAsyncData<
  {
    title: string
    imageUrl: string
    href: string
  }[]
>(
  'getLandingPageCollabs',
  async () => {
    const response = await cmsRepo.getWidget('landing-page-collabs')
    if (response.data.data.items) return response.data.data.items
    return null
  },
  { server: false }
)

const isIndexPage = computed(() => {
  return route.path === `/${locale.value}` || route.path === '/'
})
</script>
